























import { Component } from "vue-property-decorator"
import { DataTableHeader } from "vuetify"
import VueTrans from "@/mixins/VueTrans.vue"
import { Pagination } from "@/model/interfaces/pagination"
import ConfirmDeletionDialog from "@/components/elements/dialog/ConfirmDeletionDialog.vue"
import CopyUtils from "@/services/utils/CopyUtils"
import { mixins } from "vue-class-component"
import VuePagination from "@/mixins/VuePagination.vue"
import HamForm from "@/components/templateSubmission/surveyDataManagement/beneficiaryDataSheet/harmonizationSettings/ham/HamForm.vue"
import HarmonizationSettingsHamModule from "@/store/modules/harmonizationSettings/HarmonizationSettingsHamModule"
import { HarmonizationSettingSubmissionHam } from "@/model/interfaces/harmonizationSettings/ham/harmonizationSettingSubmissionHam"

@Component({
  components: { HamForm, ConfirmDeletionDialog }
})
export default class HamTable extends mixins(VueTrans, VuePagination) {
  transKey = "templatesubmission.surveydatamanagement.beneficiaryDatasheet.harmonizationSettings.table.ham."

  destroyed(): void {
    HarmonizationSettingsHamModule.resetPagination()
  }

  get loading(): boolean {
    return HarmonizationSettingsHamModule.loading
  }

  get headers(): DataTableHeader[] {
    return [
      { text: this.t("headers.convertFrom"), value: "name", sortable: true },
      { text: this.t("headers.convertTo"), value: "convertValue", sortable: true },
      { text: this.t("headers.actions"), value: "actions", sortable: false }
    ] as DataTableHeader[]
  }

  get items(): HarmonizationSettingSubmissionHam[] {
    return HarmonizationSettingsHamModule.hams
  }

  get pagination(): Pagination {
    return HarmonizationSettingsHamModule.pagination
  }

  set pagination(pagination: Pagination) {
    if (this.hasPaginationChanged(pagination, HarmonizationSettingsHamModule)) {
      HarmonizationSettingsHamModule.mergePagination(pagination)
      HarmonizationSettingsHamModule.getGlobal()
    }
  }

  get itemsPerPage(): number {
    return HarmonizationSettingsHamModule.pagination.itemsPerPage
  }

  get itemCount(): number {
    return HarmonizationSettingsHamModule.pagination.itemCount
  }

  edit(ham: HarmonizationSettingSubmissionHam): void {
    HarmonizationSettingsHamModule.setCurrent((CopyUtils.create((ham as unknown) as Record<string, unknown>) as unknown) as HarmonizationSettingSubmissionHam)
    HarmonizationSettingsHamModule.setDialogForm(true)
  }

  async remove(ham: HarmonizationSettingSubmissionHam): Promise<void> {
    HarmonizationSettingsHamModule.setLoading(true)
    HarmonizationSettingsHamModule.delete(ham).finally(() => {
      HarmonizationSettingsHamModule.setLoading(false)
    })
  }
}
